export default __webpack_public_path__ + "static/media/d.9f807daa.mp4";